import { Factory } from 'rosie';

Factory.define('ActiveCall');

Factory.define('ActiveCallWithDefaults')
  .extend('ActiveCall')
  .attr('conversationId', 'conversation-id')
  .attr('conversationItem', () => Factory.attributes('PhoneCallItemWithDefaults'))
  .attr('customer', () => Factory.attributes('CustomerProfileWithDefaults', { id: 'a-customer-id' }));



// WEBPACK FOOTER //
// ./factories/active_call_factory.js